import util from '@bmp-vue/core/api/util'
const controller = 'CDC'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  SaveProposta (th, callback) {
    if (th.model.Codigo) {
      th.model.ByPassSituacaoOnSave = true
      th.model.PropostaValorSobreposto = {
        VlrIOF: th.model.VlrIOF,
        VlrTAC: th.model.VlrTAC,
        VlrAvaliacao: th.model.VlrAvaliacao
      }
      th.$api.Multiplo.Post('SaveProposta', { dto: th.model }).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          if (callback) {
            callback()
          }
        }
      })
    }
  },
  IncluirProposta (th, callback) {
    const dtoProposta = {
      dto: {
        CodigoOperacao: th.$api.UI.Guid.New(),
        DocumentoCliente: th.$api.UI.Format.SomenteNumeros(th.model.Pessoa.DocumentoFederal),
        VlrSolicitado: th.model.VlrSolicitado,
        Prazo: th.model.Parcela.Prazo,
        TipoContrato: 'CDC',
        VlrIOF: th.model.Parcela.VlrIOF,
        PercIOF: th.model.Parcela.PercIOF,
        VlrParcela: th.model.Parcela.VlrParcela,
        VlrTAC: th.model.VlrTAC,
        DtPrimeiroVencto: th.model.DtPrimeiroVencto,
        PercJurosNegociado: th.model.Parcela.PercJurosMensal,
      },
      parametros: [{ Nome: 'SituacaoPropostaEmDigitacao', Valor: true }]
    }
    th.$api.Multiplo.Post('IncluirPropostaManual', dtoProposta).then(function (proposta) {
      if (!proposta.Result) {
        th.$api.UI.ShowError(th.$getErrorMessage('proposta.inclusao.title'), proposta.Msg)
        return
      }
      th.$api.Multiplo.Post('FindRecordProposta', { guidID: proposta.Codigo }).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.$api.UTIL.Functions.SetAllButNull(th, th, 'model', response)
          ctrl.SaveProposta(th, callback)
        }
      })
    })
  },
  SavePessoa (th, callback) {
    const dtoPessoa = {
      dto: {
        Nome: th.model.Pessoa.Nome,
        DocumentoFederal: th.model.Pessoa.DocumentoFederal,
        PessoaDadosContato: {
          Email: th.model.Pessoa.PessoaDadosContato.Email,
          TelefoneCelular1: th.model.Pessoa.PessoaDadosContato.TelefoneCelular1,
          TelefoneFixo1: th.model.Pessoa.PessoaDadosContato.TelefoneFixo1,
        }
      }
    }
    th.$api.Multiplo.Post('CreateUpdatePessoa', dtoPessoa).then(function (pessoa) {
      if (th.$api.UI.PostLoadData(pessoa, true)) {
        const dtoEndereco = {
          dto: {
            CEP: th.model.Pessoa.PessoaEndereco.CEP,
            Logradouro: th.model.Pessoa.PessoaEndereco.Logradouro,
            NroLogradouro: th.model.Pessoa.PessoaEndereco.NroLogradouro,
            Bairro: th.model.Pessoa.PessoaEndereco.Bairro,
            Complemento: th.model.Pessoa.PessoaEndereco.Complemento,
            Cidade: th.model.Pessoa.PessoaEndereco.Cidade,
            UF: th.model.Pessoa.PessoaEndereco.UF,
          },
          param: { DocumentoCliente: th.model.Pessoa.DocumentoFederal }
        }
        th.$api.Multiplo.Post('CreateUpdatePessoaEndereco', dtoEndereco).then(function (endereco) {
          if (th.$api.UI.PostLoadData(endereco, true)) {
            if (!th.model.Codigo) {
              ctrl.IncluirProposta(th, callback)
            } else {
              if (callback) {
                callback()
              }
            }
          }
        })
      }
    })
  },

})

export default ctrl
